import { type Component } from 'solid-js'
import { Trans, TransProvider } from '@mbarzda/solid-i18next'
import i18next from 'i18next'
import translations from '../assets/locales/translations.json'
import { useClerkLoadError } from '../shared/providers/clerk'

// Rendered before AppProviders, so it brings its own TransProvider and i18next instance.
const ClerkLoadError: Component = () => {
  const { retry } = useClerkLoadError()

  return (
    <TransProvider
      instance={i18next.createInstance()}
      lng="en"
      options={{ fallbackLng: 'en', resources: { en: { translation: translations.en } } }}
    >
      <div class="flex flex-col h-full items-center text-center justify-center gap-5 max-w-[360px] mx-auto">
        <span class="text-gray-900 text-base font-bold">
          <Trans key="ls_auth_load_error_title" />
        </span>
        <span class="text-gray-500 text-xs">
          <Trans key="ls_auth_load_error_message" />
        </span>
        <div class="flex justify-center gap-4 p-4">
          <button
            type="button"
            onClick={retry}
            class="min-w-[156px] rounded-md !bg-gray-800 px-3.5 py-2 text-sm font-semibold text-white shadow-sm hover:!bg-gray-700 transition duration-200"
          >
            <Trans key="ls_generic_retry" />
          </button>
        </div>
      </div>
    </TransProvider>
  )
}

export default ClerkLoadError
